export default __webpack_public_path__ + "static/N0161-65d0eba1277a4a78c7361ff7aae6c69b.png";